import { useEffect } from "react";

import { ENV } from "@/constants/env";

export const DevIndicator = () => {
    const isLocal = ENV.DEV;
    const authDev = ENV.AUTH_SVC_URL.includes("dev");
    const callDev = ENV.CALL_SVC_URL.includes("dev");
    const isDev = !isLocal && (authDev || callDev);

    useEffect(() => {
        const baseTitle = "Elitphone";

        if (isLocal) {
            document.title = "[LOC] - Elitphone";
            return;
        }

        if (isDev) {
            document.title = "[DEV] - Elitphone";
            return;
        }

        document.title = baseTitle;
    }, [isDev, isLocal]);

    return (
        <div className="fixed bottom-20 -right-14 z-[999999] flex gap-1 -rotate-90 opacity-60 pointer-events-none">
            {authDev && (
                <div className="text-xs bg-red-600 text-white rounded-tr-sm rounded-tl-sm flex items-center justify-center shadow-md px-2">
                    &lt; Auth /&gt;
                </div>
            )}
            {callDev && (
                <div className="text-xs bg-red-600 text-white rounded-tr-sm rounded-tl-sm flex items-center justify-center shadow-md px-2">
                    &lt; Call /&gt;
                </div>
            )}
        </div>
    );
};
